import { storeService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    store: {}

}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, store) {

        state.status       = 'success'
        state.store       = store
    },
    fail(state) {
        state.status       = 'fail'
    },
}

const getters = {
    status: ({status}) => status,
    store: ({store}) => store
}

const actions = {
    find({commit}, hashid) {
        commit('loading')
        return storeService.find(hashid).then(response => {
            commit('success', response.data.data)
        })
    },
    publicAccess({commit}, slug) {
        return storeService.publicAccess(slug).then(response => {
            commit('success', response.data.data)
        })
    }
}
export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}